import styled from 'styled-components'

import '@fontsource/plus-jakarta-sans'

//Formulario Register
export const FormularioRectanguloRegister = styled.form<{
  step?: number
}>`
  background-color: #fdfdfd;
  max-width: 724px;
  width: 47%;
  height: auto;
  padding: 30px 0px;
  flex-shrink: 0;
  border-radius: 10px;
  box-shadow: 4px 4px 24px 0px rgba(49, 49, 49, 0.15);
  position: absolute;
  top: 30%;
  z-index: 1;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;

  .reactanguloInterno {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    width: 350px;
    padding: 20px 0px;
    border-radius: 10px;
    border: 0.5px solid var(--Gris1, #dbdbdb);
    box-shadow: 0px 4px 8px 0px rgba(142, 146, 188, 0.05);

    @media screen and (max-width: 768px) {
      width: calc(100% - 20px);
    }
  }
  .custom-datepicker-popper {
    z-index: 10 !important; /* Asegura que el DatePicker se muestre encima de otros elementos */
  }
  .titleRegister {
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 36px */
    letter-spacing: -0.48px;
    margin: 10px 0px;
  }

  input:focus {
    outline: none;
    border: 0.5px solid #08a8d2;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px #f6f6f6 inset !important;
    -webkit-text-fill-color: black !important;
  }

  input:-moz-ui-invalid {
    box-shadow: none !important;
    background-color: #f6f6f6 !important;
  }

  input:autofill {
    background-color: #f6f6f6 !important;
  }

  @media screen and (max-width: 768px) {
    width: calc(100% - 20px);
  }
`

//Letra Titulo formulario
export const Letter = styled.p`
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.12px;
  margin-bottom: 20px;
`

//Letra Titulo formulario
export const LetterUppcarse = styled.p`
  color: var(--Gris-5, #313131);
  text-align: center;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
  margin-bottom: 20px;
`
export const LetterLabelTitle = styled.p`
  color: #0a0a18;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
  margin-bottom: 10px;
  margin-top: 22px;
`
//Letra Label
export const LetterLabel = styled.label`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.12px;
  margin-bottom: 5px;
  text-align: left;
  color: #0a0a18;
`

export const TitleForm = styled.p`
  color: var(--Oscuro, #0a0a18);
  text-shadow: 4px 4px 24px rgba(49, 49, 49, 0.15);

  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 60px */
  letter-spacing: -1.2px;
  position: absolute;
  z-index: 1;
  top: 93px;
`

export const FormularioVerifying = styled.div`
  position: relative;
  width: 100%;
  height: 30vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  .letter {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.12px;
    margin-bottom: 5px;
  }
  .contentInputs {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 89%;
    margin-bottom: 20%;
    > div:first-child {
      display: flex;
      width: 100%;
      margin-bottom: 7px;
    }
  }
`

export const ScrollBar = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 10px; // Ancho de la barra de desplazamiento
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; // Color de fondo del riel de la barra de desplazamiento
  }

  &::-webkit-scrollbar-thumb {
    background: #888; // Color de la barra de desplazamiento
    border-radius: 10px; // Redondeo de la barra de desplazamiento
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #f1f1f1; // Color de la barra de desplazamiento al pasar el mouse
  }

  .holaSvg {
    background-image: url('/assets/icons/book-square.svg');
    background-size: cover;
    width: 198px;
    height: 108px;
    position: absolute;
    z-index: 1;
    top: 0;
  }
  .letter {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.12px;
    margin-bottom: 20px;
  }
  .contentInputs {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-bottom: 20%;
    padding: 0px 30px;

    @media screen and (max-width: 768px) {
      padding: 0px 20px;
    }
  }
  .contentInputs-one {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10%;
    width: 70%;

    @media screen and (max-width: 768px) {
      width: calc(100% - 20px);
    }
  }

  .containerInput {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-bottom: 10px;
    width: 100%;
    .messageError {
      display: flex;
      color: #ec8f87;

      font-size: 11px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.12px;
      margin-top: 5px;
      margin-left: 5px;
    }
    input {
      color: #0a0a18;

      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.12px;
    }
    .content-password {
      display: flex;
      align-items: center;
      width: 100%;

      label {
        width: 100%;
        position: relative;
        align-items: center;
        display: flex;

        .password-button {
          position: absolute;
          right: 10px;
        }
      }
      svg {
        margin-left: 10px;
        cursor: pointer;
        width: 22px;
      }
    }
  }
  .contentDescriptionPassword {
    margin-top: 5px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;

    .descriptionPassword {
      color: #313131;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.12px;
    }
    .content-rules {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-left: 5px;
      gap: 3px;

      .rules {
        color: #08a8d2;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.12px;
      }
    }
  }

  .valid {
    display: none !important;
  }

  .container-inpus-options {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-content: center;
    gap: 8px;
    flex-wrap: wrap;

    .input-selected {
      border-radius: 10px;
      background: #f6f6f6;
      cursor: pointer;
      transition: background-color 0.3s;
      color: #0a0a18;
      padding: 10px 15px;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.12px;
      text-align: center;
    }

    .selected {
      border: 0.5px solid #08a8d2;
      background: #bdddeb;
    }
    .selected-show {
      min-width: 0;
      width: auto;
      overflow: hidden;
    }
  }

  .letter-answer {
    color: #313131;
    text-align: justify;

    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.12px;

    margin-bottom: 10px;
  }

  .other-option {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.12px;
    margin-top: 10px;
    color: #313131;
    cursor: pointer;
  }

  .button-gmail {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    padding: 10px;
    color: #0a0a18;
    text-align: center;

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    letter-spacing: -0.32px;
    margin-bottom: 10px;
  }

  .button-facebook {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #1877f2;
    border-radius: 10px;
    border: none;
    padding: 10px;
    color: #f8f8f8;
    text-align: center;

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    letter-spacing: -0.32px;
  }

  .content-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 17px;
  }

  .svg-facebook {
    background-image: url('/assets/icons/facebook-icon.svg');
    background-size: cover;
    width: 26px;
    height: 23px;
    margin-right: 10px;
  }
`
export const FormularioRegister = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(/assets/form-bg.svg);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  .copiaDIGA-AH {
    background-image: url(/assets/icons/Copia-DIGA-AH-1.svg);
    background-size: cover;
    width: 100%;
    height: 100vh;
    position: absolute;
    z-index: -1;
  }
`

export const StepProgress = styled.div<{
  $completionPercentages: { [key: number]: number }
  $currentStep: number
}>`
  width: 100%;
  margin: 30px 0px;

  .stepper-wrapper {
    width: 100%;
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .stepper-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;

    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.24px;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  .stepper-item::before {
    position: absolute;
    content: '';
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 12px;
    left: -50%;
    z-index: 2;
  }

  ${(props) =>
    Object.keys(props.$completionPercentages)
      .map((key) => {
        const step = Number(key) // Convierte la clave a número
        const isCompleted = step < props.$currentStep
        const isCurrent = step === props.$currentStep
        const width = isCompleted
          ? 100
          : isCurrent
            ? props.$completionPercentages[step]
            : 0

        return `
        .stepper-item:nth-child(${step})::after {
          content: "";
          position: absolute;
          border-bottom: 2px solid ${
            isCompleted || isCurrent ? '#08a8d2' : '#ccc'
          };
          width: ${width}%;
          top: 12px;
          left: 50%; // Asegúrate de que comienza desde el lado izquierdo
          z-index: 3;
        }
        `
      })
      .join('')}

  .stepper-item .step-counter {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #f6f6f6;
    margin-bottom: 6px;
    color: #8e92bc;
    border: solid 1px #08a8d2;
  }

  .stepper-item.active {
    font-weight: bold;
  }

  .stepper-item.completed .step-counter {
    background-color: #08a8d2;
    color: #f4f4f4;
  }

  .stepper-item:first-child::before {
    content: none;
  }
  .stepper-item:last-child::after {
    content: none;
  }
`

export const ProgressIndicator = styled.div<{ widthPercentage: number }>`
position: relative;
  width: 100%;
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  .stepper-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  .stepper-item::before {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 12px;
    left: -50%;
    z-index: 2;
  }

  .stepper-item::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 12px;
    left: 50%;
    z-index: 2;
  }

  .stepper-item .step-counter {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #f6f6f6;
    margin-bottom: 6px;
    color: #8e92bc;
    border: solid 1px #08a8d2;
  }

  .stepper-item.active {
    font-weight: bold;
  }

  .stepper-item.completed .step-counter {
    background-color: #08a8d2;
    color: #f4f4f4;
  }

  .stepper-item:first-child::before {
    content: none;
  }
  .stepper-item:last-child::after {
    content: none;
  }
  .stepper-item.completed::before {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width:100%
    top: 12px;
    left: 50%;
    z-index: 3;
  }
  .stepper-item.completed::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #08a8d2;
    width: ${(props: { widthPercentage: number }) => (props.widthPercentage ? props.widthPercentage : '0')}%;
    top: 12px;
    left: 50%;
    z-index: 3;
  }
`
